import { useEffect, useRef, useState } from 'react';
import { getCurrentDateTime, request, toast } from '../../../../../../utils';
import { IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Table } from '../../../../../../components';

const TABLE_HEADER = [
  { header: 'IPD No.', accessor: 'ipd_no' },
  { header: 'UHID No.', accessor: 'uhid' },
  { header: 'Patient Name', accessor: (row) => `${row.patient.first_name} ${row.patient.last_name}` },
  { header: 'Admission Date', accessor: (row) => `${getCurrentDateTime('date', row.admissionDate)}` },
  { header: 'Address', accessor: 'patient.address.address' },
  { header: 'Sponsor', accessor: 'patient.sponsor.name' },
  { header: 'Mobile No.', accessor: 'patient.address.mobile' }
];

export const IPDSearchHandlerBillManagement = ({ onClose, onAdd }) => {
  const [input, setInput] = useState('');
  const [patientData, setPatientData] = useState({ loading: false, data: [] });
  const requestIdRef = useRef(0);

  useEffect(() => {
    // Debounce keystrokes; requestId guard drops out-of-order responses
    const requestId = ++requestIdRef.current;
    const timer = setTimeout(async () => {
      const lowercasedInput = input.toLowerCase().trim();
      try {
        const query = {};
        if (lowercasedInput) {
          query.patientName = lowercasedInput;
        }
        const response = await request('/indoor-registeration-detail-list', {
          method: 'GET',
          query: query
        });
        if (requestId !== requestIdRef.current) return; // a newer search superseded this one
        if (response?.success) {
          setPatientData({ loading: false, data: response?.data || [] });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setPatientData({ loading: false, data: [] });
        }
      } catch (error) {
        if (requestId !== requestIdRef.current) return;
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setPatientData({ loading: false, data: [] });
      }
    }, input ? 300 : 0);

    return () => clearTimeout(timer);
  }, [input]);

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };



  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Indoor Registeration Search
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
        <MuiTextField
          sx={{
            width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
          }}
          label="Search Patient"
          variant="outlined"
          value={input}
          onChange={handleChange}
        />
      </Stack>
      <Table
        sx={{ mt: 0.5 }}
        columns={TABLE_HEADER}
        data={patientData?.data || []}
        onRowClick={(row) => {
          onAdd(row.ipd_no);
          onClose();
        }}
      />
    </>
  );
};
